module.exports = __webpack_public_path__ + "career-icon-internet.3VR_8ZGo.svg";